import axios from 'axios';
import { chatHost, ttsHost, wsHost, platformId, debug } from './config.js';

function _get(endpoint, params) {
  if (platformId) { params = params || {}; params.platformId = platformId; }
  const url = chatHost + endpoint + (params ? ('?' + new URLSearchParams(params)) : '');
  const credentialsInclude = { credentials: "include" };
  return fetch(url, credentialsInclude).then(response => response.json());
}

function _post(endpoint, params) {
  if (platformId) { params = params || {}; params.platformId = platformId; }
  return fetch(chatHost+endpoint, 
    {
      method: 'POST',
      body: JSON.stringify(params),
      credentials: "include",
      headers:{'Content-Type': 'application/json'}
    }).then(response => response.json());
}

const emptySet = new Set();
function splitIncomingMessages(messages, ignoreMessages = emptySet) {
  return messages.filter(u => !u.incoming && !ignoreMessages.has(u.messageId)).map(m => m.text).flatMap(str => str.split("\n")).filter(m => m);
}


function sendToBot(msg, callbackFn, ignoreMessages) {  
  var params = { 
    text: msg
  };
  if (msg === undefined) {
    params.start = true;
  }
  _post('/voice-message', params).then(
    function (data) {
        var outgoingMessages = splitIncomingMessages(data.messages, ignoreMessages);
        callbackFn(outgoingMessages);
    }
  );
};



function getRelevantTopics(callbackFn) {  
  _get('/get-relevant-topics').then(
    function (data) {
        callbackFn(data.topics);
    }
  );
};


function fetchAboutYou(callbackFn) {  
  _get('/about-you').then(
    function (data) {
        callbackFn(data.result);
    }
  );
};

function endSession(callbackFn) {  
  _post('/voice-message', { step: 'terminate_session'}).then(
    function (data) {
        callbackFn(splitIncomingMessages(data.messages));
    }
  );
};

function restart(callbackFn, ignoreMessages) {  
  _post('/voice-message', { restart: true}).then(
    function (data) {
        callbackFn(splitIncomingMessages(data.messages, ignoreMessages));
    }
  );
};

function startTopic(topicName, callbackFn, ignoreMessages) {  
  _post('/voice-message', { topic: topicName }).then(
    function (data) {
        callbackFn(splitIncomingMessages(data.messages, ignoreMessages));
    }
  );
};

function makeSpeech(text, voice) {
  return axios.post(ttsHost + '/talk', { text, voice });
}

async function getSpeechToken() {
  return (await axios.get(ttsHost + '/get-speech-token', { })).data;
}

function sendFeedback(data, callbackFn) {
  return _post('/submit-feedback', data).then(callbackFn);
}


function getTopic(topic) {  
  return _get('/get-topic', { platform: 'voice', topic });
};


let interimTextWs = null;
let userId = null;
function openInterimTextSocket(callbackFn) {
  _get('/get-user-info').then(function (data) {
    userId = data.id;

    const wsUrl = `${wsHost}/interim-speech?transport=websocket&userId=${userId}`;

    interimTextWs = new WebSocket(wsUrl);
    interimTextWs.onmessage = function(event) {
      debug(JSON.parse(event.data));
      callbackFn(JSON.parse(event.data));
    };
    interimTextWs.onerror = function(error) {
      console.error('WebSocket Error:', error);
    };  
  });
}


export { sendToBot, getRelevantTopics, fetchAboutYou, restart, endSession, makeSpeech, getTopic, startTopic, sendFeedback, openInterimTextSocket, getSpeechToken };